export default "__VITE_ASSET__thZG4MlV__"